// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"7a72bf0a","400":"c50a2e32","453":"71af1719"}[chunkId] + ".chunk.js";
};